"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function sphtx(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M4.5 8.91825V8.65125H10.8127V8.91825H4.5ZM4.5 8.142V7.875H10.8127V8.142H4.5ZM7.1625 16.122V9.45225H7.416V16.122H7.1625ZM7.8975 16.122V9.45225H8.15025V16.122H7.8975ZM19.3215 15.576L16.473 12.5662L16.6515 12.378L19.5 15.387L19.3215 15.576ZM12.3892 7.875L15.2377 10.8847L15.0592 11.073L12.2108 8.064L12.3892 7.875ZM18.8018 16.125L15.9532 13.1152L16.1318 12.9263L18.9802 15.936L18.8018 16.125ZM11.8702 8.424L14.7188 11.433L14.5395 11.622L11.691 8.613L11.8702 8.424ZM15.936 12L16.1152 11.811L19.3215 8.424L19.5 8.613L16.2938 12L16.1152 12.189L15.7748 12.549L15.5955 12.738L12.39 16.125L12.2115 15.936L15.4177 12.549L15.5963 12.36L15.936 12ZM15.5955 11.262L18.8025 7.875L18.981 8.064L15.7748 11.451L15.5963 11.64L15.2557 12L15.0765 12.189L11.871 15.576L11.6917 15.387L14.898 12L15.0765 11.811L15.4177 11.451L15.5955 11.262Z", fill: color }));
}
exports["default"] = sphtx;
//# sourceMappingURL=sphtx.js.map